import { Chip } from '@mui/material';
import { EventStatus } from 'common/dto-types/event-dto';

const EventStatusCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case EventStatus.Confirmed:
            return <Chip color="success" label="Confirmed" size="small" variant="light" />;
        case EventStatus.Cancelled:
            return <Chip color="error" label="Cancelled" size="small" variant="light" />;
        case EventStatus.Postponed:
            return <Chip color="error" label="Postponed" size="small" variant="light" />;
        case EventStatus.ToBeConfirmed:
            return <Chip color="warning" label="To be confirmed" size="small" variant="light" />;
        case EventStatus.Tentative:
            return <Chip color="warning" label="Tentative" size="small" variant="light" />;
        case EventStatus.New:
            return <Chip color="info" label="New" size="small" variant="light" />;
        case EventStatus.Updated:
            return <Chip color="primary" label="Updated" size="small" variant="light" />;
        default:
            return <p>Unknown</p>;
    }
};

export default EventStatusCell;
